import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { trackPageView } from './utils/analytics';
import './App.css';

import CookieBanner from './Components/CookieBanner';

// Nuovo sito
import HomePage from './Components/HomePage';
import ProgettiPage from './Components/ProgettiPage';
import CollaboraPage from './Components/CollaboraPage';

// Pagine prodotti esistenti (invariate)
import Icoach from './Components/Icoach';
import IcoachPrivacy from './Components/IcoachPrivacy';
import IcoachTerms from './Components/IcoachTerms';
import CrewBoat from './Components/CrewBoat';
import CrewBoatPricingPage from './Components/CrewBoatPricingPage';
import CrewBoatPrivacyPolicy from './Components/CrewBoatPrivacyPolicy';
import CrewBoatTerms from './Components/CrewBoatTerms';
import IPairly from './Components/iPairly';
import IPairlyPrivacy from './Components/iPairlyPrivacy';
import AccademiaCampania from './Components/AccademiaCampania';
import ServiziPage, { ServizioPage } from './Components/Servizi';
import Veyro from './Components/Veyro';
import VeyroTrainer from './Components/VeyroTrainer';
import VeyroPrivacy from './Components/VeyroPrivacy';
import VeyroTerms from './Components/VeyroTerms';
import PrivacyPolicy from './Components/PrivacyPolicy';
import TermsAndConditions from './Components/TermsAndConditions';
import NotFound from './Components/NotFound';
import { PageSEO } from './utils/seo';

// Metadati delle route i cui componenti non montano un proprio <PageSEO>.
// `canonical` diverso dal path = pagina che ripete un documento già pubblicato altrove.
const ROUTE_SEO = {
  '/policy': { title: 'Privacy Policy', description: 'Informativa sulla privacy di VMDProject: dati raccolti, finalità del trattamento, diritti GDPR e contatti del titolare.' },
  '/terms-and-conditions': { title: 'Termini e Condizioni', description: "Termini e condizioni d'uso del sito e dei servizi VMDProject." },
  '/icoach/policy': { title: 'iCoach — Privacy Policy', description: "Informativa sulla privacy dell'app iCoach: dati raccolti, finalità e diritti dell'utente." },
  '/icoach/terms': { title: 'iCoach — Termini di Servizio', description: "Termini di servizio dell'app iCoach per personal trainer e atleti." },
  '/crewboat/pricing': { title: 'CrewBoat — Prezzi e Piani', description: 'Piani e prezzi di CrewBoat, l\'app per la gestione di equipaggi, turni e manutenzione delle imbarcazioni.' },
  '/crewboat/policy': { title: 'CrewBoat — Privacy Policy', description: "Informativa sulla privacy dell'app CrewBoat: dati raccolti, finalità e diritti dell'utente." },
  '/crewboat/terms': { title: 'CrewBoat — Termini di Servizio', description: "Termini di servizio dell'app CrewBoat per la gestione degli equipaggi nautici." },
  '/ipairly/policy': { title: 'iPairly — Privacy Policy e Termini', description: "Informativa sulla privacy e termini d'uso dell'app iPairly." },
  '/ipairly/terms': { title: 'iPairly — Privacy Policy e Termini', description: "Informativa sulla privacy e termini d'uso dell'app iPairly.", canonical: '/ipairly/policy' },
  '/veyro/policy': { title: 'Veyro — Privacy Policy', description: 'Informativa sulla privacy delle app Veyro e Veyro Trainer: dati raccolti, finalità e diritti.' },
  '/veyro/terms': { title: 'Veyro — Termini di Servizio', description: 'Termini di servizio delle app Veyro e Veyro Trainer.' },
  '/veyro-trainer/policy': { title: 'Veyro Trainer — Privacy Policy', description: 'Informativa sulla privacy delle app Veyro e Veyro Trainer: dati raccolti, finalità e diritti.', canonical: '/veyro/policy' },
  '/veyro-trainer/terms': { title: 'Veyro Trainer — Termini di Servizio', description: 'Termini di servizio delle app Veyro e Veyro Trainer.', canonical: '/veyro/terms' },
};

function AppRoutes() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  const path = location.pathname.replace(/\/+$/, '') || '/';
  const routeSeo = ROUTE_SEO[path];

  return (
    <>
    {routeSeo && <PageSEO canonical={path} {...routeSeo} />}
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* ── Sito principale ── */}
        <Route path="/" element={<HomePage />} />
        <Route path="/progetti" element={<ProgettiPage />} />
        <Route path="/collabora" element={<CollaboraPage />} />
        <Route path="/servizi" element={<ServiziPage />} />
        <Route path="/servizi/consulenza-tecnica" element={<ServizioPage slug="consulenza-tecnica" />} />
        <Route path="/servizi/sviluppo-siti-web" element={<ServizioPage slug="sviluppo-siti-web" />} />
        <Route path="/servizi/sviluppo-app-mobile" element={<ServizioPage slug="sviluppo-app-mobile" />} />
        <Route path="/servizi/sviluppo-saas-gestionali" element={<ServizioPage slug="sviluppo-saas-gestionali" />} />
        <Route path="/servizi/manutenzione-app" element={<ServizioPage slug="manutenzione-app" />} />

        {/* ── Case study ── */}
        <Route path="/progetti/accademia-campania" element={<AccademiaCampania />} />

        {/* ── Policy generali ── */}
        <Route path="/policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

        {/* ── iCoach ── */}
        <Route path="/icoach" element={<Icoach />} />
        <Route path="/icoach/policy" element={<IcoachPrivacy />} />
        <Route path="/icoach/terms" element={<IcoachTerms />} />

        {/* ── CrewBoat ── */}
        <Route path="/crewboat" element={<CrewBoat />} />
        <Route path="/crewboat/pricing" element={<CrewBoatPricingPage />} />
        <Route path="/crewboat/policy" element={<CrewBoatPrivacyPolicy />} />
        <Route path="/crewboat/terms" element={<CrewBoatTerms />} />

        {/* ── iPairly ── */}
        <Route path="/ipairly" element={<IPairly />} />
        <Route path="/ipairly/policy" element={<IPairlyPrivacy />} />
        <Route path="/ipairly/terms" element={<IPairlyPrivacy />} />

        {/* ── Veyro ── */}
        <Route path="/veyro" element={<Veyro />} />
        <Route path="/veyro/policy" element={<VeyroPrivacy />} />
        <Route path="/veyro/terms" element={<VeyroTerms />} />

        {/* ── Veyro Trainer (stessi documenti legali: coprono entrambe le app) ── */}
        <Route path="/veyro-trainer" element={<VeyroTrainer />} />
        <Route path="/veyro-trainer/policy" element={<VeyroPrivacy />} />
        <Route path="/veyro-trainer/terms" element={<VeyroTerms />} />

        {/* ── Fallback ── */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AppRoutes />
      <CookieBanner />
    </div>
  );
}

export default App;
